import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import qs from 'qs';
import { MedVoxTaskCurrent } from '../../models/MedVox/MedVoxTask';
import { medVoxParameters } from '../../hooks/components/useMedVoxTasks/constants';
import { Status } from '../../models/common/Status';
import { RootState } from '../store';
import { apiClientWithApi } from '../../utils/http';

export interface MedVoxTaskState {
  items: MedVoxTaskCurrent[];
  totalItemsCount: number;
  status: Status;
}

export interface MedVoxTaskResponse {
  items: MedVoxTaskCurrent[];
  totalItemsCount: number;
}

export interface MedVoxTaskRequest {
  startDate: string;
  endDate: string;
  clinicIds: string[];
  state: number | null;
  phone: string;
  pageNumber: number;
  pageSize: number;
}

const initialState: MedVoxTaskState = {
  items: [],
  totalItemsCount: 0,
  status: {
    responseLoading: true,
    responseError: null,
    requestSuccess: null,
    requestError: null,
  },
};

export const loadMedVoxTaskExcel = createAsyncThunk(
  'medVoxTask/load-tasks',
  async (file: FormData, { rejectWithValue }) => {
    try {
      const response = await apiClientWithApi.post('task/import', file, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.message);
      } else return rejectWithValue('Не удалось загрузить файл!');
    }
  },
);

export const getMedVoxTasks = createAsyncThunk(
  'medVoxTask/getMedVoxTasks',
  async (request: MedVoxTaskRequest, { rejectWithValue }) => {
    try {
      const response = await apiClientWithApi.get<MedVoxTaskResponse>('task', {
        params: {
          [medVoxParameters.startDate]: request.startDate,
          [medVoxParameters.endDate]: request.endDate,
          [medVoxParameters.pageIndex]: request.pageNumber,
          [medVoxParameters.pageSize]: request.pageSize,
          [medVoxParameters.phone]: request.phone,
          [medVoxParameters.clinicIds]: request.clinicIds,
          [medVoxParameters.state]: request.state,
        },
        paramsSerializer: function (params) {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.message);
      } else return rejectWithValue('Не удалось получить список заданий!');
    }
  },
);

export const medVoxTaskSlice = createSlice({
  name: 'medVoxTask',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getMedVoxTasks.pending, (state) => {
        state.status.responseLoading = true;
        state.status.responseError = null;
        return state;
      })
      .addCase(getMedVoxTasks.fulfilled, (state, action) => {
        state.status.responseLoading = false;
        state.status.responseError = null;
        state.items = action.payload.items;
        state.totalItemsCount = action.payload.totalItemsCount;
        return state;
      })
      .addCase(getMedVoxTasks.rejected, (state) => {
        state.status.responseLoading = false;
        state.status.responseError = 'Не удалось загрузить звонки';
        return state;
      })
      .addCase(loadMedVoxTaskExcel.fulfilled, (state) => {
        state.status.requestSuccess = 'Новые задания сохранены!';
        state.status.requestError = null;
      })
      .addCase(loadMedVoxTaskExcel.rejected, (state) => {
        state.status.requestSuccess = null;
        state.status.requestError = 'Не удалось загрузить файл!';
      });
  },
});

export default medVoxTaskSlice.reducer;

export const selectRoboCallTasks = (state: RootState) => state.medVoxTask.items;

export const medVoxTaskStatus = (state: RootState) => state.medVoxTask.status;

export const totalRoboCallTasks = (state: RootState) =>
  state.medVoxTask.totalItemsCount;
